module.exports = __webpack_public_path__ + "static/media/boxes-alt.da5d1dbf.svg";